// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"Loader_spinnerWrapper__1cyLy","spinner":"Loader_spinner__2zjOg","scale":"Loader_scale__2aUta","label":"Loader_label__EFHMd"};